import { ReactNode } from "react";
import { motion } from "framer-motion";

const HeroBanner = ({ image, title, subtitle, children }) => {
  return (
    <section className="relative h-[50vh] md:h-[60vh] flex items-center overflow-hidden">
      <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
      <div className="hero-overlay" />
      <div className="relative z-10 container-max px-4 sm:px-6 lg:px-8 w-full">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-3xl md:text-5xl lg:text-6xl font-montserrat font-bold text-primary-foreground mb-4"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg md:text-xl text-primary-foreground/80 font-roboto max-w-3xl"
          >
            {subtitle}
          </motion.p>
        )}
        {children}
      </div>
    </section>
  );
};

export default HeroBanner;